<script>
  export let primary = false;
  export let secondary = false;
  export let active = false;
  export let large = false;
  export let outlined = false;
  export let rounded = false;
  export let disabled = false;
  export let href = null;
</script>

<style lang="stylus">
  .button
    box-sizing border-box
    display inline-block
    min-width 66px
    min-height 38px
    padding 8px 26px
    border-radius 8px
    transition background-color 0.2s ease-in-out
    cursor pointer
    outline none
    border 0
    font-family LabGrotesque, Helvetica, Arial, sans-serif
    font-size 16px
    font-weight 500
    text-align center
    line-height 24px

    & > *
      vertical-align bottom

    :global(.coin-icon)
      vertical-align bottom

  a.button
    text-decoration none

  .primary
    background $violet
    color white

    :global(svg)
      stroke white

    @media $bp.desktop
      &:not(.disabled):hover
        background-color: darken(@background, 20%)

  .secondary
    background: rgba($violet, 0.1)
    color $violet

    :global(svg)
      stroke $violet

    @media $bp.desktop
      &:not(.disabled):hover
        background-color: darken(@background, 20%)

    &.active
      background lighten($violet, 30%)

  .large
    font-size 20px
    padding 18px 20px
    min-height 66px

  .outlined
    border 1px solid $grey
    background white
    transition border-color 0.2s ease-in-out

    @media $bp.desktop
      &:not(.disabled):hover
        border-color darken($grey, 10%)

  .rounded
    border-radius 100px

  .disabled
    background: rgba($violet, 0.1)
    color lighten($violet, 10%)
    cursor progress
</style>

{#if !href}
  <button
    class="button"
    class:primary
    class:secondary
    class:active
    class:large
    class:outlined
    class:rounded
    class:disabled
    disabled={disabled}
    on:click
    {...$$restProps}
  >
    <slot />
  </button>
{:else}
  <a
    href={href}
    class="button"
    class:primary
    class:secondary
    class:active
    class:large
    class:outlined
    class:rounded
    class:disabled
    on:click
    {...$$restProps}
  >
    <slot />
  </a>
{/if}
